import { render } from "./cookie.vue?vue&type=template&id=144b2918&scoped=true"
import script from "./cookie.vue?vue&type=script&lang=js"
export * from "./cookie.vue?vue&type=script&lang=js"

import "./cookie.vue?vue&type=style&index=0&id=144b2918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144b2918"]])

export default __exports__